import { render } from "./EggCanvas.vue?vue&type=template&id=98579f14"
import script from "./EggCanvas.vue?vue&type=script&lang=js"
export * from "./EggCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__